export default function ($http) {
    return function (vehicleId, keeperId, moveTo) {
        return $http.put(`api/vehicles/${ vehicleId }/keepers/${ keeperId }/move${ moveTo }`)
                    .then(x => {
                        const correct = x.data.result;
                        if (!correct) {
                            throw new Error(`Could not move keeper ${ keeperId } ${ moveTo }`);
                        }
                    });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/keeperMove.js